var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"lg":"6","md":"6","sm":"6","cols":"12"}},[_c('UserInfo')],1),_c('v-col',{attrs:{"lg":"6","md":"6","sm":"6","cols":"12"}},[_c('UserDetails')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }